export const finish = 'FINISH_ONBOARDING';
